module.exports = __webpack_public_path__ + "ca81ff11f3535344848fbacfda111c87.svg";